import { useTranslation } from 'react-i18next'
import { Press } from '@dorixona/ui'
import type { Category } from '../features/catalog/api'
import { Photo } from './Photo'
import { categoryTint } from './product'

export interface CategoryTileProps {
  category: Category
  onOpen: (id: number) => void
}

export function CategoryTile({ category, onOpen }: CategoryTileProps) {
  const { t } = useTranslation('catalog')

  return (
    <Press
      squish="card"
      className="cattile"
      onPress={() => {
        onOpen(category.id)
      }}
    >
      <div className="ti" style={{ background: categoryTint(category.id) }}>
        <Photo src={category.cover} alt="" icon="i-jar" iconSize={24} />
      </div>
      <div>
        <div className="tn">{category.name}</div>
        <div className="tc num">{t('cashback', { percent: category.cb })}</div>
      </div>
    </Press>
  )
}
